// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_ORGANIZATION_TYPE,
    SETTING_CREATE_ORGANIZATION_TYPE_SUCCESS,
    SETTING_UPDATE_ORGANIZATION_TYPE,
    SETTING_UPDATE_ORGANIZATION_TYPE_SUCCESS,
    SETTING_LOAD_ORGANIZATION_TYPE,
    SETTING_LOAD_ORGANIZATION_TYPE_SUCCESS,
    SETTING_DELETE_ORGANIZATION_TYPE,
    SETTING_DELETE_ORGANIZATION_TYPE_SUCCESS,

    SETTING_LOAD_ORGANIZATION,
    SETTING_LOAD_ORGANIZATION_SUCCESS,
    SETTING_CREATE_ORGANIZATION,
    SETTING_CREATE_ORGANIZATION_SUCCESS,
    SETTING_UPDATE_ORGANIZATION,
    SETTING_UPDATE_ORGANIZATION_SUCCESS,
    SETTING_DELETE_ORGANIZATION,
    SETTING_DELETE_ORGANIZATION_SUCCESS,

    SETTING_LOAD_CUSTOMER,
    SETTING_LOAD_CUSTOMER_SUCCESS,
    SETTING_CREATE_CUSTOMER,
    SETTING_CREATE_CUSTOMER_SUCCESS,
    SETTING_UPDATE_CUSTOMER,
    SETTING_UPDATE_CUSTOMER_SUCCESS,
    SETTING_DELETE_CUSTOMER,
    SETTING_DELETE_CUSTOMER_SUCCESS,
    // SETTING_UPDATE_CUSTOMER_STATUS,
    // SETTING_UPDATE_CUSTOMER_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getOrganizationType --------------------- //
export const getOrganizationType = (data, token) => ({
    type: SETTING_LOAD_ORGANIZATION_TYPE,
    payload: data,
    token
});
export const getOrganizationTypeSuccess = (data, list) => ({
    type: SETTING_LOAD_ORGANIZATION_TYPE_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createOrganizationType --------------------- //
export const addOrganizationType = (data, token) => ({
    type: SETTING_CREATE_ORGANIZATION_TYPE,
    payload: data,
    token
});
export const addOrganizationTypeSuccess = () => ({
    type: SETTING_CREATE_ORGANIZATION_TYPE_SUCCESS,
});

// // -------------------- updateOrganizationType --------------------- //
export const updateOrganizationType = (data, token) => ({
    type: SETTING_UPDATE_ORGANIZATION_TYPE,
    payload: data,
    token
});
export const updateOrganizationTypeSuccess = () => ({
    type: SETTING_UPDATE_ORGANIZATION_TYPE_SUCCESS,
});

// // -------------------- deleteOrganizationType --------------------- //
export const deleteOrganizationType = (data, token) => ({
    type: SETTING_DELETE_ORGANIZATION_TYPE,
    payload: data,
    token
});
export const deleteOrganizationTypeSuccess = () => ({
    type: SETTING_DELETE_ORGANIZATION_TYPE_SUCCESS,
});

// // -------------------- getOrganization --------------------- //
export const getOrganization = (data, token) => ({
    type: SETTING_LOAD_ORGANIZATION,
    payload: data,
    token
});
export const getOrganizationSuccess = (data, list) => ({
    type: SETTING_LOAD_ORGANIZATION_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createOrganization --------------------- //
export const createOrganization = (data, token) => ({
    type: SETTING_CREATE_ORGANIZATION,
    payload: data,
    token
});
export const createOrganizationSuccess = () => ({
    type: SETTING_CREATE_ORGANIZATION_SUCCESS,
});

// // -------------------- updateOrganization --------------------- //
export const updateOrganization = (data, token) => ({
    type: SETTING_UPDATE_ORGANIZATION,
    payload: data,
    token
});
export const updateOrganizationSuccess = () => ({
    type: SETTING_UPDATE_ORGANIZATION_SUCCESS,
});

// // -------------------- deleteOrganization --------------------- //
export const deleteOrganization = (data, token) => ({
    type: SETTING_DELETE_ORGANIZATION,
    payload: data,
    token
});
export const deleteOrganizationSuccess = () => ({
    type: SETTING_DELETE_ORGANIZATION_SUCCESS,
});

// // -------------------- getCustomer --------------------- //
export const getCustomer = (data, token) => ({
    type: SETTING_LOAD_CUSTOMER,
    payload: data,
    token
});
export const getCustomerSuccess = (data, list) => ({
    type: SETTING_LOAD_CUSTOMER_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createCustomer --------------------- //
export const createCustomer = (data, token) => ({
    type: SETTING_CREATE_CUSTOMER,
    payload: data,
    token
});
export const createCustomerSuccess = () => ({
    type: SETTING_CREATE_CUSTOMER_SUCCESS,
});

// // -------------------- updateCustomer --------------------- //
export const updateCustomer = (data, token) => ({
    type: SETTING_UPDATE_CUSTOMER,
    payload: data,
    token
});
export const updateCustomerSuccess = () => ({
    type: SETTING_UPDATE_CUSTOMER_SUCCESS,
});

// // -------------------- deleteCustomer --------------------- //
export const deleteCustomer = (data, token) => ({
    type: SETTING_DELETE_CUSTOMER,
    payload: data,
    token
});
export const deleteCustomerSuccess = () => ({
    type: SETTING_DELETE_CUSTOMER_SUCCESS,
});

// // // -------------------- updateChangeStatusCustomer --------------------- //
// export const updateChangeStatusCustomer = (data, token) => ({
//     type: SETTING_UPDATE_CUSTOMER_STATUS,
//     payload: data,
//     token
// });
// export const updateChangeStatusCustomerSuccess = () => ({
//     type: SETTING_UPDATE_CUSTOMER_STATUS_SUCCESS,
// });
